import Duck, { Selector } from 'extensible-duck';
import { tokenDuck } from '../../store/jwtMiddleware';
import withHooks from '../../util/genericEntityDuck/withHooks';

const storeKey = 'auth';
const namespace = 'app';

const duck = withHooks(
  new Duck({
    namespace,
    store: storeKey,
    types: ['LOGIN_START', 'LOGIN_SUCCESS', 'LOGIN_FAIL', 'LOGOUT'],
    initialState: {
      loading: false,
      loginFailed: false,
      error: undefined,
    },
    reducer: (state, action, { types: typesInput, initialState }) => {
      switch (action.type) {
        case typesInput.LOGIN_START:
          return { ...state, loading: true, loginFailed: false, loggedIn: false, error: undefined };
        case typesInput.LOGIN_SUCCESS:
          return {
            ...initialState,
          };

        case typesInput.LOGIN_FAIL:
          return {
            ...initialState,
            loginFailed: true,
            error: action.error,
          };

        case typesInput.LOGOUT:
          return initialState;

        default:
          return state;
      }
    },
    selectors: {
      root: state => state[namespace][storeKey],
      token: state => tokenDuck.selectors.token(state),
      isLoading: new Selector(selectorsInput => state => selectorsInput.root(state).loading),
      error: new Selector(selectorsInput => state => selectorsInput.root(state).error),
    },
    creators: ({ types: typesInput }) => ({
      loginStart: (email, password) => ({ type: typesInput.LOGIN_START, email, password }),
      loginSuccess: () => ({ type: typesInput.LOGIN_SUCCESS }),
      loginError: (error = {}) => ({ type: typesInput.LOGIN_FAIL, error: error.message }),
      logout: () => ({ type: typesInput.LOGOUT }),
    }),
  })
);

export { duck as default, namespace, storeKey };
export const { creators, reducer, types, selectors, hooks } = duck;
